import { createRouter, type RouteComponent } from "@tanstack/react-router"
import { routeTree } from "src/routeTree.gen"
import { SpinnerView } from "src/views/SpinnerView/SpinnerView"

import { DefaultErrorBoundaryView } from "../views/DefaultErrorBoundaryView/DefaultErrorBoundaryView"

export const router = createRouter({
	routeTree,
	defaultPendingComponent: SpinnerView,
	defaultErrorComponent: DefaultErrorBoundaryView,
	context: {
		isLoggedIn: false,
		online: false,
		activeOrganizationId: null,
		activeProjectId: null,
	},
})

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}

	interface StaticDataRouteOption {
		hideLeftSlideOut?: boolean
		leftSlideOut?: RouteComponent
		hideRightSlideOut?: boolean
		rightSlideOut?: RouteComponent
		topBar?: RouteComponent
		background?: RouteComponent
	}
}
